export default function inputFilled(){
    const inputs = document.querySelectorAll('.form__input,select.form__select');
    inputs.forEach((input, index) => {

        if ((input).value != '' && !input.classList.contains('filled')) {
            input.classList.add('filled');
        }

        let eventList = ['input', 'change', 'keyup', 'paste'];
        for (let ev of eventList) {
            input.addEventListener(ev, () => {
                if ((<HTMLInputElement>input).value != '') {
                    input.classList.add('filled');
                } else {
                    input.classList.remove('filled');
                }
            });
        }

    });
}

document.addEventListener('DOMContentLoaded', () => {
    inputFilled();
});
